<script>
// import parallax from 'vue-parallaxy'

export default {
  // components: {
  //   parallax
  // },
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: '',
    },
    customClass: {
      type: [String, Object],
      default: '',
    },
  },
  data() {
    return {
      scrollTop: 0,
    }
  },
  computed: {
    filterPage() {
      const routerMap = ['member', 'about-menu', 'contact-menu']
      return !['article', 'articleIsLive', 'event'].includes(this.type) && !routerMap.includes(this.$route.name)
    },
  },
  mounted() {
    this.onScroll()
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    // openSearch() {
    //   console.log('search')
    //   this.$emit('openSearch')
    // },
    onScroll() {
      this.scrollTop = this.getWindowScrollTop()
    },
    getWindowScrollTop() {
      let windowScrollTop = 0

      if (typeof window.pageYOffset !== 'undefined') {
        windowScrollTop = window.pageYOffset
      } else if (typeof document.compatMode !== 'undefined' && document.compatMode !== 'BackCompat') {
        windowScrollTop = document.documentElement.scrollTop
      } else if (typeof document.body !== 'undefined') {
        windowScrollTop = document.body.scrollTop
      }

      return windowScrollTop
    },
    openFilter() {
      // console.log('filter')
      this.$emit('openFilter')
    },
  },
}
</script>
<template>
  <div
    :class="[
      $style.banner,
      { isArticle: type === 'article' },
      { isArticleLive: type === 'articleIsLive' },
      { isEvent: type === 'event' },
      { isMobilePage: filterPage },
      { isMobileHasBg: type === 'isMobileHasBg' },
      customClass,
    ]"
  >
    <template v-if="image || (['article', 'articleIsLive', 'event'].includes(type) && image)">
      <div class="banner__parallax">
        <!-- <div 
          class="banner__image" 
          :style="{ backgroundImage: `url(${image || require('@assets/images/about/banner.png')})`,
          }"
        >
        </div> -->
        <img alt="" class="banner__image" :class="{ isArticle: ['article'].includes(type) && image }" :src="image || require('@assets/images/about/banner.png')" />
      </div>
      <!-- <parallax
        section-class="banner__parallax"
        :speed-factor="0.2"
      >
        <img
          alt=""
          :src="image || require('@assets/images/about/banner.jpg')"
        > 
      </parallax> -->
    </template>
    <template v-else>
      <div class="banner__bg"></div>
    </template>
    <div class="container h-100 position-relative bannerFixed">
      <div class="bannerBox">
        <div class="bannerInner">
          <BaseBreadcrumb class="breadCrumb mb-1 d-md-block d-none" :custom-class="customClass" />
          <h2 class="title font-medium">
            {{ title }}
          </h2>
          <span v-if="subTitle" class="color-white subTitle">
            {{ subTitle }}
          </span>
          <div v-if="type === 'articleIsLive'" class="isLive-icon mt-3">LIVE</div>
          <div v-if="filterPage" class="searchData__list d-flex color-gray-6 text-sm d-md-none">
            <!-- <div 
              class="saerchData__item text-center isSearch"
              @click="openSearch"
            >
              <i class="fal fa-search text-base"></i>ㄑ
              <div>搜尋</div>
            </div> -->
            <div class="saerchData__item text-center isFilter" @click="openFilter">
              <i class="fal fa-filter text-base"></i>
              <div>篩選</div>
            </div>
          </div>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
.banner {
  position: relative;
  z-index: 1;
  min-height: 300px;
  overflow: hidden;

  @include max-lg {
    min-height: 175px;
  }

  // @include max-md {
  //   min-height: 160px;
  // }

  &:global {
    &.isArticle {
      .bannerBox {
        .title {
          font-size: 40px;
          line-height: 1.4;

          @include max-lg {
            font-size: 2rem;
            letter-spacing: 0.2em;
          }

          @include max-md {
            font-size: 1.5rem;
            letter-spacing: 0.2em;
          }
        }
        .subTitle {
          // text-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
          @include max-md {
            font-size: 0.875rem;
          }
        }
      }

      .bannerInner {
        width: calc(100% - 540px);
        @media screen and (max-width: 1200px) {
          width: calc(100% - 470px);
        }
        @include max-lg {
          width: 100%;
        }
      }

      .category {
        position: relative;
        display: inline-block;
        padding: 5px 10px;
        margin-top: 10px;
        margin-right: 10px;
        font-size: 0.875rem;
        color: #fff;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 5px;
      }
    }

    &.isArticleLive {
      // padding-top: 26%;
      .bannerBox {
        .title {
          // width: 762px;
          font-size: 40px;
          line-height: 1.4;
          // max-width: calc(100% - 278px);
          @include max-lg {
            // max-width: 100%;
          }
        }
      }
    }

    &.isEvent {
      .bannerBox {
        .title {
          font-size: 40px;
          @include max-md {
            font-size: 1.5rem;
          }
        }
      }
    }

    &.isArticle,
    &.isEvent,
    &.isArticleLive {
      :global {
        .bannerBox {
          min-height: 350px;
          height: auto;
          padding: 1.1rem 0;
          @include max-md {
            min-height: 214px;
          }
        }
      }
    }
    // &.isHasNoSearch {
    //   .isSearch {
    //     display: none;
    //   }
    // }
    &.isHasNoFilter {
      .isFilter {
        display: none;
      }
    }
    &.isMobilePage {
      @include max-md {
        min-height: 60px;
        height: 60px;
        position: relative;
        z-index: 1220;
        :global {
          .banner {
            &__parallax {
              display: none;
            }
            &__bg {
              display: none;
            }
          }
          .bannerFixed {
            position: fixed !important;
            height: 60px !important;
            background: #fff;
            border-bottom: 2px solid $color-gray-2;
          }
          .bannerBox {
            padding: 0;
            height: 100%;
            .title {
              align-self: center;
              color: $color-gray-7;
              margin: 0;
            }
            .bannerInner {
              display: flex;
              justify-content: space-between;
              .saerchData {
                &__list {
                  margin-left: 10px;
                  flex-shrink: 0;
                }
                &__item {
                  &:not(:last-child) {
                    margin-right: 30px;
                    position: relative;
                    &:before {
                      content: '';
                      position: absolute;
                      width: 1px;
                      height: 80%;
                      background: $color-gray-2;
                      top: 50%;
                      transform: translateY(-50%);
                      right: -15px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    &.isMobileHasBg {
      @include max-md {
        .banner__parallax {
          &:before {
            background: transparent linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(18, 27, 33, 0.76) 100%) 0% 0% no-repeat padding-box;
            opacity: 0.5;
          }
        }
        .bannerBox {
          .title {
            text-align: center;
            color: $color-gray-7;
            font-size: 1.5rem;
          }
        }
      }
    }
    &.isStyleWhite {
      background: #f5f5f5;
      &.isStyleBgWhite {
        background: #fff;
      }
      .bannerBox {
        .bannerInner {
          .title {
            color: #3e3a39;
            text-shadow: none;
          }
        }
      }
    }
    &.isDefaultBgEventItem {
      .banner__image {
        @include max-lg {
          display: none;
        }
      }
      .banner__parallax {
        @include max-lg {
          background-color: $color-primary;
        }
      }
      .bannerBox {
        .bannerInner {
          @include max-lg {
            width: 100%;
            .title {
              color: #fff;
            }
          }
        }
        .el-tag {
          @include max-lg {
            border: 1px solid #fff;
          }
        }
      }
    }
    &.isDefaultBannerImage {
      .banner__image {
        @include max-lg {
          object-position: 59% 0;
        }
        @include max-md {
          object-position: 64% 0;
        }
      }
      .bannerBox {
        .bannerInner {
          @include max-lg {
            width: calc(100% - 100px);
          }
        }
      }
    }
    // &.isNotParallax {
    //   .banner__parallax {
    //     height: 100%;
    //     transform: translateY(0) !important;
    //   }
    //   .banner__image {
    //     &.isArticle {
    //       background-position: center;
    //       object-position: center;
    //     }
    //   }
    // }
  }

  :global {
    .banner {
      &__parallax {
        width: 100%;
        overflow: hidden;
        height: 100%;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
      }
      &__image {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-position: center;
        background-size: cover;
        object-fit: cover;
        object-position: center;
        height: 100%;
        width: 100%;
      }
      &__bg {
        pointer-events: none;
        height: 100% !important;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: $color-primary;
      }
    }

    .bannerBox {
      padding: 5.1rem 0;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      @include max-lg {
        padding: 4.3rem 0;
      }

      .breadCrumb {
        margin-left: -15px;
        background: transparent;
      }

      .title {
        position: relative;
        z-index: 5;
        font-size: 50px;
        letter-spacing: 0.12em;
        color: #fff;
        // text-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
        @include max-lg {
          font-size: 2rem;
          letter-spacing: 0.2em;
        }

        @include max-md {
          font-size: 1.25rem;
          letter-spacing: 0.2em;
          text-shadow: none;
        }
      }
    }
  }
}
</style>
